import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../../services/user.service';
import { NgxBootstrapConfirmService } from '../../shared/ngx-bootstrap-confirm/ngx-bootstrap-confirm.service';
import { SocketService } from '../../services/SocketService';
import { getAllOrdersSelector } from '../../store/state/selectors/matchboard.selectors';
import { Store } from '@ngrx/store';
import { MatchBoardState } from '../../store/state/reducers/matchboard.reducers';
import { Order } from '../../models/orderbook.model';

@Component({
  selector: 'app-order-panel',
  templateUrl: './order-panel.component.html'
})
export class OrderPanelComponent implements OnInit {

  @ViewChild('tabGroup') tabGroup;
  isSuperUser: boolean;
  allOrders: Array<Order>;

  constructor(private readonly userService: UserService,
              private readonly socketService: SocketService,
              private readonly store: Store<MatchBoardState>,
              private readonly confirmService: NgxBootstrapConfirmService) {
  }

  ngOnInit() {
    this.isSuperUser = this.userService.isSuperUser();
    this.store.select(getAllOrdersSelector).subscribe((allOrders) => {
      if (!allOrders) {
        return;
      }
      this.allOrders = Object.values(allOrders);
    });
  }

  cancelAllOrdersInSystem() {
    const options = {
      title: 'CAUTION! All orders will be removed in the system!',
      confirmLabel: 'Yes',
      declineLabel: 'Cancel',
      headerLabel: 'Are you sure you want to cancel all orders?'
    };
    this.confirmService.confirm(options).then((res: boolean) => {
      if (res) {
        this.socketService.send('cancelAllOrders', {});
      }
    });
  }
}
